export default __webpack_public_path__ + "static/media/Clasp of a Thousand Blossoms.8d955f61.jpg";